import { DirectiveFunction } from 'vue'
import { mask } from 'vue-the-mask'

// O v-mask do vue-the-mask com máscara vazia apaga o valor do campo, e a diretiva não pode ser ligada
// condicionalmente no template. Sem máscara, esta diretiva desliga o handler do vue-the-mask e não faz nada.
const mascaraOpcionalDirective: DirectiveFunction = (el, binding, vnode, oldVnode) => {
  if (binding.value) {
    mask(el, binding, vnode, oldVnode)
    return
  }

  const input = el.tagName.toUpperCase() === 'INPUT' ? el : el.querySelector('input')

  if (input) {
    input.oninput = null
  }
}

export default mascaraOpcionalDirective
